import type { SerializedDockview } from 'dockview';

/**
 * DockView layouts are keyed as `${view}::${tabLabel}`.
 * When PMS Full view routes were renamed, map old keys onto the new ones.
 *
 * `operations::Transactions` is copied (not removed) so PMS Lite under
 * `/portfolio/operations/transactions` keeps working.
 */
export const USER_LAYOUT_KEY_MIGRATIONS = [
  { from: 'portfolio-management::Transactions', to: 'positions::Transactions' },
  { from: 'operations::Transactions', to: 'treasury-management::Transactions' },
] as const;

export function migrateUserLayoutMapKeys(
  layoutMap: Record<string, SerializedDockview>
): Record<string, SerializedDockview> {
  let changed = false;
  const migrated = { ...layoutMap };

  for (const { from, to } of USER_LAYOUT_KEY_MIGRATIONS) {
    if (migrated[from] != null && migrated[to] == null) {
      migrated[to] = migrated[from];
      changed = true;
    }
  }

  return changed ? migrated : layoutMap;
}
